import BaseService from "@client.services/baseService";

export default class NotificationService extends BaseService {
  constructor() {
    super("notification", true);
  }

  async delete(ids) {
    return super.delete("", { ids });
  }

  async markAsRead(id, value) {
    return super.put("markAsRead", { id, value });
  }

  async getAll(filter) {
    return super.api("list", filter);
  }

  async regenerate(filter) {
    return super.post(`regenerate?${new URLSearchParams(filter).toString()}`);
  }

  async getInsightEvents(id) {
    return super.api(`${id}/events`);
  }

  async getInsightEventResponses(id) {
    return super.api(`${id}/event/responses`);
  }
}
